import React, { useState } from "react";
import { toast } from "react-toastify";
import StarryNightSky from "./Stars";
import ThankYouModal from "./Thankyou";

const RegisterForm = () => {
  const showText = `Thank you for your interest in COALER! We will get back to you soon.`;
  const [showModal, setShowModal] = useState(false);
  const [fullName, setFullName] = useState("");
  const [companyName, setCompanyName] = useState("");
  const [selectedRoles, setSelectedRoles] = useState([]);
  const [formData, setFormData] = useState({
    name: "",
    email: "",
    companyName: "",
    requirement: ""
  });
  const [isSubmitting, setIsSubmitting] = useState(false);

  const validateEmail = (email) => /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({ ...prev, [name]: value }));
  };

  const toggleRole = (role) => {
    setSelectedRoles((prev) =>
      prev.includes(role) ? prev.filter((r) => r !== role) : [...prev, role]
    );
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setIsSubmitting(true);

    if (!validateEmail(formData.email)) {
      toast.error("Please enter a valid email address.", {
        position: "top-left",
      });
      setIsSubmitting(false);
      return;
    }

    const updatedFormData = {
      ...formData,
      name: fullName,
      companyName: companyName || "None",
      requirement: selectedRoles.length > 0 ? selectedRoles : ["Other"],
    };

    try {
      const response = await fetch(
        "https://website-backend.starlabs.co.in/api/coaler-contact",
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify(updatedFormData),
        }
      );

      if (response.ok) {
        toast.success("Message sent successfully!");
        setFormData({
          name: "",
          email: "",

        });
        setFullName("");
        setCompanyName("");
        setSelectedRoles([]);
        setShowModal(true);
      } else {
        throw new Error("Network response was not ok.");
      }
    } catch (error) {
      console.error("FAILED...", error);
      toast.error("Failed to send message. Please try again later.");
    } finally {
      setIsSubmitting(false);
    }
  };

  return (
    <section
      className="relative text-white bg-black bg-cover w-full flex justify-center p-10"
      id="contact"
    >
      <StarryNightSky height="100vh" />

      <div className="relative mx-auto w-screen md:w-[1000px] rounded-[48px] backdrop-blur-[300px] bg-[#FFFFFF1A] p-8">
        <div className="pt-8 pr-5 pb-8 pl-6 grid gap-8 lg:grid-cols-[1fr_1.5fr]">
          <div className="flex flex-col gap-4 mt-12 z-10">
            <h1 className="font-black text-4xl leading-[1.3]">
              Sign up for early access
            </h1>
            <p className="font-normal text-[18px] leading-[150%] tracking-[0%]">
              Please fill out the form below to register your interest.
            </p>
          </div>

          <div className="relative flex justify-center">
            <div className="absolute top-5 bottom-20 md:w-[550px] w-[250px] h-full rounded-full pointer-events-none bg-[#5A8CF0] opacity-50 shadow-[0_0_150px_#5A8CF0,_0_0_250px_#34518A] blur-3xl"></div>

            <form
              onSubmit={handleSubmit}
              className="mt-12 space-y-10 relative z-10 w-full px-8"
            >
              <div>
                <label
                  htmlFor="fullName"
                  className="block mb-1 font-semibold text-white"
                >
                  Full name
                </label>
                <input
                  id="fullName"
                  name="fullName"
                  value={fullName}
                  onChange={(e) => setFullName(e.target.value)}
                  className="w-full p-2 text-gray-200 bg-transparent border-b-2 border-gray-600 focus:outline-none focus:border-blue-500"
                  placeholder="Enter your full legal name here"
                  required
                />
              </div>

              <div>
                <label
                  htmlFor="email"
                  className="block mb-1 font-semibold text-white"
                >
                  Email address
                </label>
                <input
                  id="email"
                  name="email"
                  type="email"
                  value={formData.email}
                  onChange={handleChange}
                  className="w-full p-2 text-gray-200 bg-transparent border-b-2 border-gray-600 focus:outline-none focus:border-blue-500"
                  placeholder="Enter your email here"
                  required
                />
              </div>

              <div>
                <label
                  htmlFor="companyName"
                  className="block mb-1 font-semibold text-white"
                >
                  Company name (Optional)
                </label>
                <input
                  id="companyName"
                  name="companyName"
                  value={companyName}
                  onChange={(e) => setCompanyName(e.target.value)}
                  className="w-full p-2 text-gray-200 bg-transparent border-b-2 border-gray-600 focus:outline-none focus:border-blue-500"
                  placeholder="Enter your organization's name here"
                />
              </div>

              {/* Role Selector */}
              <div className="mb-6 w-full">
                <label className="block text-sm font-semibold text-white mb-2">
                  How do you plan to use the app?
                </label>
                <p className="text-xs text-gray-300 mb-4">
                  You can select multiple options
                </p>
    <div className="flex flex-col gap-4 sm:grid sm:grid-cols-4 sm:w-full sm:gap-4">
  {/* First Row - For Smaller Screens */}
  <div className="sm:hidden flex justify-center w-full bg-gray-700 rounded-l-full rounded-r-full overflow-hidden">
    {["Vendor", "Transporter"].map((role, index) => {
      const isSelected = selectedRoles.includes(role);
      return (
        <button
          key={role}
          type="button"
          onClick={() => toggleRole(role)}
          className={`
            flex items-center justify-center gap-1 px-4 py-2 text-sm font-medium transition-all w-full
            ${isSelected ? "bg-white text-black" : "text-white"}
            ${index === 0 ? "rounded-l-full" : ""}
            ${index === 1 ? "rounded-r-full" : ""}
            ${!isSelected ? "hover:bg-gray-600" : ""}
          `}
        >
          {isSelected && (
            <img
              src="/Selectedicon.png"
              alt="tickmark"
              className="w-[16px] h-[16px]"
            />
          )}
          {role}
        </button>
      );
    })}
  </div>

  {/* Second Row - For Smaller Screens */}
  <div className="sm:hidden flex justify-center w-full bg-gray-700 rounded-l-full rounded-r-full overflow-hidden">
    {["Buyer", "Other"].map((role, index) => {
      const isSelected = selectedRoles.includes(role);
      return (
        <button
          key={role}
          type="button"
          onClick={() => toggleRole(role)}
          className={`
            flex items-center justify-center gap-1 px-4 py-2 text-sm font-medium transition-all w-full
            ${isSelected ? "bg-white text-black" : "text-white"}
            ${index === 0 ? "rounded-l-full" : ""}
            ${index === 1 ? "rounded-r-full" : ""}
            ${!isSelected ? "hover:bg-gray-600" : ""}
          `}
        >
          {isSelected && (
            <img
              src="/Selectedicon.png"
              alt="tickmark"
              className="w-[16px] h-[16px]"
            />
          )}
          {role}
        </button>
      );
    })}
  </div>

  {/* For Desktop: Grid Layout with 4 buttons */}
  <div className="hidden  sm:flex sm:w-full sm:justify-between">
    {["Vendor", "Transporter", "Buyer", "Other"].map((role, index) => {
      const isSelected = selectedRoles.includes(role);
      return (
        <button
          key={role}
          type="button"
          onClick={() => toggleRole(role)}
          className={`
            flex items-center justify-center gap-1 px-4 py-2 text-sm font-medium transition-all w-full
            ${isSelected ? "bg-white text-black" : "text-white"}
            ${index === 0 ? "rounded-l-full" : ""}
            ${index === 3 ? "rounded-r-full" : ""}
            ${!isSelected ? "hover:bg-gray-600" : ""}
          `}
        >
          {isSelected && (
            <img
              src="/Selectedicon.png"
              alt="tickmark"
              className="w-[16px] h-[16px]"
            />
          )}
          {role}
        </button>
      );
    })}
  </div>
</div>



              </div>

              <div className="w-full text-center">
                <button
                  type="submit"
                  className="w-8/12 p-2 font-semibold text-center text-white transition-all rounded-lg lg:w-full lg:p-3 bg-[#1B0073] hover:bg-blue-600"
                  disabled={isSubmitting}
                >
                  {isSubmitting ? "Submitting..." : "Submit"}
                </button>
              </div>
            </form>
          </div>
        </div>
      </div>

      {showModal && <ThankYouModal texttoShow={showText} onClose={() => setShowModal(false)} />}
    </section>
  );
};

export default RegisterForm;
